import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import * as LabReqActions from './lab-req.actions';
import { LabReqEntity } from './lab-req.models';

export const LAB_REQ_FEATURE_KEY = 'labReq';

export interface State extends EntityState<LabReqEntity> {
  selectedId?: string | number; // which LabReq record has been selected
  loading: boolean; // has the LabReq list is loading
  error?: string | null; // last known error (if any)
}

export interface LabReqPartialState {
  readonly [LAB_REQ_FEATURE_KEY]: State;
}

export function selectLabReqId(labReq: LabReqEntity): string {
  //In this case this would be optional since primary key is id
  return labReq._id;
}

export const labReqAdapter: EntityAdapter<LabReqEntity> =
  createEntityAdapter<LabReqEntity>({
    selectId: selectLabReqId
  });

export const initialState: State = labReqAdapter.getInitialState({
  // set initial required properties
  loading: false,
  saving: false
});

const labReqReducer = createReducer(
  initialState,
  on(LabReqActions.loadLabReq, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(LabReqActions.loadLabReqSuccess, (state, { labReq }) =>
    labReqAdapter.setAll([labReq], {
      ...state,
      loading: false,
      selectedId: labReq._id
    })
  ),
  on(LabReqActions.loadLabReqFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false
  })),
  on(LabReqActions.loadPatientLabReqs, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(LabReqActions.loadPatientLabReqsSuccess, (state, { labReqs }) =>
    labReqAdapter.setAll(labReqs, { ...state, loading: false })
  ),
  on(LabReqActions.loadPatientLabReqsFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false
  }))
);

export function reducer(state: State | undefined, action: Action) {
  return labReqReducer(state, action);
}
